const initCommunicationsWidget = () => {
    const selector = "[communications-widget]";
    const communicationsWidget = document.querySelector(selector);
    if (communicationsWidget) {
        const config = new CarouselConfig();
        config.sliderSelector = `${selector} [data-slider]`;
        config.cellAlign = CellAlign.center;
        config.contain = true;
        config.autoPlay = 3000;
        config.wrapAround = true;
        config.showArrows = false;
        config.activateCustomButtons = false;
        config.showDots = false;
        config.groupCells = true;
        config.adaptiveHeight = false;
        config.imagesLoaded = true;
        const responsiveCarousel = new ResponsiveCarousel();
        responsiveCarousel.initCarousel(config);
    }
};
